export default "__VITE_ASSET__Xz2JHi8j__"